import { render, staticRenderFns } from "./publicActivities.vue?vue&type=template&id=2e4f7f8c&scoped=true"
import script from "./publicActivities.vue?vue&type=script&lang=js"
export * from "./publicActivities.vue?vue&type=script&lang=js"
import style0 from "./publicActivities.vue?vue&type=style&index=0&id=2e4f7f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f7f8c",
  null
  
)

export default component.exports